import { render, staticRenderFns } from "./AgnosticBiomarker2.vue?vue&type=template&id=e40b28ee&scoped=true"
import script from "./AgnosticBiomarker2.vue?vue&type=script&lang=js"
export * from "./AgnosticBiomarker2.vue?vue&type=script&lang=js"
import style0 from "./AgnosticBiomarker2.vue?vue&type=style&index=0&id=e40b28ee&prod&lang=scss&scoped=true"
import style1 from "./AgnosticBiomarker2.vue?vue&type=style&index=1&id=e40b28ee&prod&lang=scss&scoped=true"
import style2 from "./AgnosticBiomarker2.vue?vue&type=style&index=2&id=e40b28ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40b28ee",
  null
  
)

export default component.exports